export const stopPropagation = (element: Element|NodeListOf<Element>, event: string): void => {
    let array
    if(element instanceof NodeList) array = element
    else { array = [element] }
    array.forEach(el => el?.addEventListener(event, (event: Event) => event.stopPropagation()))
}